import Vue from 'vue'

Vue.filter('rating', (value) =>
  new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    maximumFractionDigits: 1,
  }).format(value)
)
